import { createApiSlice } from "@common";
import { CRUD_ENGAGEMENT_LEVEL } from "@routes";

const apiConfig = [
  {
    name: "addEngagementLevel",
    method: "post",
    url: CRUD_ENGAGEMENT_LEVEL,
    stateKey: "message",
  },

  {
    name: "getEngagementLevel",
    method: "get",
    url: CRUD_ENGAGEMENT_LEVEL,
    stateKey: "data",
  },

  {
    name: "updateEngagementLevel",
    method: "put",
    url: CRUD_ENGAGEMENT_LEVEL,
    stateKey: "message",
  },

  {
    name: "deleteEngagementLevel",
    method: "delete",
    url: CRUD_ENGAGEMENT_LEVEL,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("engagementLevel", apiConfig, customReducers);
const engagementLevelSlice = slice;

export default engagementLevelSlice.reducer;

export const {
  addEngagementLevel,
  getEngagementLevel,
  updateEngagementLevel,
  deleteEngagementLevel,
} = thunks;

export const { rowSelect } = actions;
